import { Auth } from "aws-amplify";

export async function getUser() {
  try {
    const userInfo = await Auth.currentAuthenticatedUser()
      .then((userInfo) => userInfo)
      .catch(() => Auth.federatedSignIn({ customProvider: "FederateOIDC" }));
    return userInfo;
  } catch (e) {
    console.error(e.message);
  }
}